import { AuthPackage } from '@mentimeter/auth';

let authPackage;
const createAuthPackage = () => {
  authPackage = new AuthPackage({
    baseUrl: process.env.NEXT_PUBLIC_EU_CORE_URL,
  });
  return authPackage;
};

export default authPackage || createAuthPackage();
